import React from "react";

import { ItemSelect, mapSelectorItemsToReactSelect } from "~/integrations/actionItemIntegration/selectors";

import type { TeamInfo } from "./LinearAllColumns";

export function StateSelector({
	teamId,
	stateId,
	setStateId,
	states,
	isError,
}: {
	teamId?: string;
	stateId?: string;
	setStateId: (s: string) => void;
	states?: TeamInfo["states"];
	isError?: boolean;
}) {
	const options = mapSelectorItemsToReactSelect(states || []);

	return (
		<ItemSelect
			shouldAssumeDefault
			placeholder="Select status"
			options={options}
			selectedId={stateId}
			setSelectedId={setStateId}
			isLoading={teamId !== undefined && !states}
			isDisabled={!teamId}
			isError={isError}
		/>
	);
}
